module.exports = __webpack_public_path__ + "img/cpxl.68a0019e.png";